import { render, staticRenderFns } from "./UploadDocumentModal.vue?vue&type=template&id=5094caf7&scoped=true"
import script from "./UploadDocumentModal.vue?vue&type=script&lang=js"
export * from "./UploadDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentModal.vue?vue&type=style&index=0&id=5094caf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094caf7",
  null
  
)

export default component.exports